import { PageHero, SHELL, Reveal, Mono } from "@/components/bits";
import { VAULT_ACTIONS } from "@/lib/data";
import { Lock } from "lucide-react";

const CHAIN = ["USDC", "VERA VAULT", "ASSET POOL", "REAL-WORLD ASSETS"];

export default function Vaults() {
    return (
        <div data-testid="vaults-page">
            <PageHero
                label="CAPITAL ENTRY"
                title={"CAPITAL ENTRY, PROGRAMMABLE."}
                sub="Vaults are the interface between capital providers and asset pools: capital enters in USDC, is allocated to verified pools, and settles back — all as programmable, rule-based flows on Arc."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="grid lg:grid-cols-2 gap-14 items-start">
                        <Reveal>
                            <div className="glass-card p-8 md:p-10" data-testid="vault-flow-diagram">
                                <Mono className="text-vera-gold2 block mb-8">THE VAULT FLOW</Mono>
                                <div className="flex flex-col items-stretch max-w-sm mx-auto">
                                    {CHAIN.map((c, i) => (
                                        <div key={c} className="w-full">
                                            <div className={`px-5 py-4 border font-mono text-[11px] tracking-[0.25em] text-center ${c === "VERA VAULT" ? "border-vera-gold/60 text-vera-gold2 bg-vera-gold/10" : "border-vera-blue/40 text-[#A8D2FF] bg-vera-deep/60"}`}>
                                                {c}
                                            </div>
                                            {i < CHAIN.length - 1 && (
                                                <div className="relative w-px h-9 bg-white/10 mx-auto overflow-hidden" aria-hidden="true">
                                                    <span className="flow-dot" style={{ "--flow-dist": "36px", animationDelay: `${i * 0.6}s` }} />
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Reveal>

                        <div>
                            <Reveal>
                                <p className="text-vera-mut text-base leading-relaxed mb-4">
                                    A vault enforces states and constraints — eligibility, limits, queues — through defined registries. Participation is
                                    rule-based, never guaranteed, and every action settles in USDC on Arc.
                                </p>
                            </Reveal>
                            <Reveal delay={0.08}>
                                <div className="flex items-center gap-3 mb-8" data-testid="vault-disabled-note">
                                    <Lock className="w-4 h-4 text-vera-gold" aria-hidden="true" />
                                    <Mono className="text-vera-mut">ALL ACTIONS DISABLED UNTIL CONTRACTS ARE CONNECTED</Mono>
                                </div>
                            </Reveal>
                            <div className="grid grid-cols-2 gap-4">
                                {VAULT_ACTIONS.map((a, i) => (
                                    <Reveal key={a.id} delay={i * 0.05}>
                                        <button
                                            type="button"
                                            disabled
                                            title="Contracts not connected — actions unlock when VERA contracts go live"
                                            data-testid={`vault-action-${a.id}`}
                                            className="w-full glass-card px-6 py-6 text-left opacity-60 cursor-not-allowed hover:border-vera-gold/40 transition-colors"
                                        >
                                            <div className="flex items-center justify-between mb-3">
                                                <Mono className="text-vera-white">{a.label}</Mono>
                                                <Lock className="w-3.5 h-3.5 text-vera-gold/70" aria-hidden="true" />
                                            </div>
                                            <p className="text-xs text-vera-mut">{a.hint}</p>
                                            <p className="font-mono text-[8px] tracking-[0.2em] text-vera-mut/60 mt-4">DISABLED — DEMO STATE</p>
                                        </button>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                    </div>
                </SHELL>
            </section>
        </div>
    );
}
